import { FileBlob, LTCAppeal, LtcHearing } from "@scts/models";
import {filterAppeals, filterDecisions, filterHearings} from './filter';
import { searchAppeals, searchDecisions, searchHearings } from "./search";
  
export const filterAndSearchDecisions = (
  blobItemsArray: FileBlob[],
  decisionFilter: string,
  appealTypeFilter: string,
  appealReasonFilter: string,
  respondentFilter: string,
  searchTerm: string) => {

    let currentBlobItemsArray: FileBlob[] = blobItemsArray;

    currentBlobItemsArray = filterDecisions(
      currentBlobItemsArray, 
      decisionFilter, 
      appealTypeFilter, 
      appealReasonFilter, 
      respondentFilter
    );
    
    if (searchTerm.length > 2) {
      currentBlobItemsArray = searchDecisions(currentBlobItemsArray, searchTerm);
    } 

    return currentBlobItemsArray;
};

export const filterAndSearchHearings = (
  hearingsArray: LtcHearing[],
  dateFilter: string,
  appealTypeFilter: string,
  respondentFilter: string,
  searchTerm: string) => {

    let currentHearingsArray: LtcHearing[] = hearingsArray;

    currentHearingsArray = filterHearings(currentHearingsArray, dateFilter, appealTypeFilter, respondentFilter);

    if (searchTerm.length > 2) {
      currentHearingsArray = searchHearings(currentHearingsArray, searchTerm);
    }

    return currentHearingsArray;
}; 

export const filterAndSearchAppeals = (
  appealsArray: LTCAppeal[],
  appealTypeFilter: string,
  appealSubTypeFilter: string,
  respondentFilter: string,
  searchTerm: string) => {

    let currentAppealsArray: LTCAppeal[] = appealsArray;

    currentAppealsArray = filterAppeals(currentAppealsArray, appealTypeFilter, appealSubTypeFilter, respondentFilter);

    if (searchTerm.length > 2) {
      currentAppealsArray = searchAppeals(currentAppealsArray, searchTerm);
    }

    return currentAppealsArray;
}; 